export default __webpack_public_path__ + "assets/media/soccer.39fa20ed.png";